import React from "react"

import { cn } from "@/modules/helpers/hooks/shared/utils"

const TabTag = ({
  label,
  className,
  Icon,
  active = false,
  isTextGradient = false,
  textClassName,
  onClick,
  isCapitalize = true
}: {
  label: string
  className?: string
  textClassName?: string // className cho text
  Icon?: React.ElementType
  active?: boolean
  isTextGradient?: boolean
  onClick?: () => void
  isCapitalize?: boolean
}) => {
  return (
    <div
      className={cn(
        "flex items-center gap-1 px-2.5 w-fit shadow-xs rounded-full bg-background h-6  ",
        className,
        {
          "bg-gradient-primary border border-primary-100": active
        }
      )}
      onClick={onClick}
    >
      {Icon && <Icon size={16} color={active ? "white" : "#045664"} />}
      <p
        className={cn(
          "text-[10px]  whitespace-nowrap text-primary-800 cursor-pointer",
          textClassName,
          {
            "text-white": active,
            "text-gradient-primary": isTextGradient,
            capitalize: isCapitalize
          }
        )}
      >
        {label}
      </p>
    </div>
  )
}

export { TabTag }
